import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { MasterDetailListEntry, SimpleMasterDetailListEntry } from '@sdbn/common';
import { TransportOption } from '../../transport-options.model';


export class TransportOptionEditorDialogData {
  transportOption: TransportOption;
}

@Component({
  selector: 'app-transport-option-editor',
  templateUrl: './transport-option-editor.component.html',
  styleUrls: ['./transport-option-editor.component.scss']
})
export class TransportOptionEditorComponent {

  menuEntries = [
    new SimpleMasterDetailListEntry({key: 'labeling', listTitleDictionaryKey: 'tmc-yard.ui.admin.transport-options-administration.editor.menu.labeling'}),
    new SimpleMasterDetailListEntry({key: 'control', listTitleDictionaryKey: 'tmc-yard.ui.admin.transport-options-administration.editor.menu.control'}),
    new SimpleMasterDetailListEntry({key: 'validation', listTitleDictionaryKey: 'tmc-yard.ui.admin.transport-options-administration.editor.menu.validation'}),
    new SimpleMasterDetailListEntry({key: 'loading', listTitleDictionaryKey: 'tmc-yard.ui.admin.transport-options-administration.editor.menu.loading'}),
    new SimpleMasterDetailListEntry({key: 'parameter', listTitleDictionaryKey: 'tmc-yard.ui.admin.transport-options-administration.editor.menu.parameter'}),
    new SimpleMasterDetailListEntry({key: 'files', listTitleDictionaryKey: 'tmc-yard.ui.admin.transport-options-administration.editor.menu.files'})
  ];

  selectedMenuEntry = this.menuEntries[0];
  currentViewKey = 'labeling';

  // hilfsvariable für color picker, direkter zugriff auf form.control.value geht bei nutzung von ahead of time compiler nicht
  colorPickerColor: string;

  showMinimumSelectedOptions = false;
  showErrorMinSelectedOptionsMin = false;

  keys = Object.keys;

  optionValid = false;

  transportOption: TransportOption;

  constructor(
    public dialogRef: MatDialogRef<TransportOptionEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TransportOptionEditorDialogData,
    public translationService: TranslationService) {
    this.transportOption = data.transportOption;
    this.updateValidity();
  }

  private updateValidity() {

    this.optionValid = this.transportOption.name.values.length > 0;
    console.log('validating', this.optionValid, this.transportOption);
  }

  public confirmDialog() {
    this.dialogRef.close(this.data.transportOption);
  }

  public cancelDialog() {
    this.dialogRef.close();
  }

  public onDetailsChanged() {
    this.updateValidity();
  }

  onSelectionChanged(value: MasterDetailListEntry) {
    const item = value as SimpleMasterDetailListEntry;
    this.selectedMenuEntry = item;
    this.currentViewKey = item.key;
  }
}
